"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deimos = void 0;
const Colony_1 = require("../../../colonies/Colony");
const ColonyName_1 = require("../../../colonies/ColonyName");
const ColonyBenefit_1 = require("../../../colonies/ColonyBenefit");
class Deimos extends Colony_1.Colony {
    constructor() {
        super(...arguments);
        this.name = ColonyName_1.ColonyName.DEIMOS;
        this.description = 'Hazards';
        this.buildType = ColonyBenefit_1.ColonyBenefit.PLACE_HAZARD_TILE;
        this.tradeType = ColonyBenefit_1.ColonyBenefit.ERODE_SPACES_ADJACENT_TO_HAZARDS;
        this.tradeQuantity = [0, 0, 1, 1, 2, 2, 3];
        this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_MC_PER_HAZARD_TILE;
        this.details = [
            'Place a hazard tile next to no other tile',
            'Erode n spaces adjacent to hazard tiles',
            'Gain 1 M€ per hazard tile on Mars',
        ];
    }
}
exports.Deimos = Deimos;
//# sourceMappingURL=Deimos.js.map